import { useState } from "react";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const links = [
  ["Manifesto", "#manifesto", "nav-manifesto-link"],
  ["Services", "#services", "nav-services-link"],
  ["Pricing", "#pricing", "nav-pricing-link"],
  ["Founder", "#founder", "nav-founder-link"],
  ["FAQ", "#faq", "nav-faq-link"],
];

const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });

export default function Navbar({ openBooking }) {
  const [open, setOpen] = useState(false);
  const navButton = (label, target, testId) => (
    <button
      key={target}
      data-testid={testId}
      onClick={() => { setOpen(false); scrollTo(target); }}
      className="font-mono text-xs uppercase tracking-[0.22em] text-slate-400 transition-colors hover:text-cyan-300"
    >
      {label}
    </button>
  );

  return (
    <header data-testid="site-navigation" className="fixed inset-x-0 top-4 z-50 px-4">
      <nav className="glass-nav mx-auto flex max-w-5xl items-center justify-between rounded-full px-5 py-3">
        <button data-testid="nav-logo-button" onClick={() => scrollTo("#top")} className="group flex items-center gap-3">
          <img src="/tybra-logo-transparent.png" alt="Tybra Digital logo" data-testid="nav-logo-image" className="h-12 w-auto object-contain transition-transform duration-300 group-hover:-rotate-1 group-hover:scale-[1.03]" />
        </button>
        <div className="hidden items-center gap-7 lg:flex">{links.map(([label, target, testId]) => navButton(label, target, testId))}</div>
        <div className="hidden lg:block">
          <Button data-testid="nav-book-call-button" onClick={() => openBooking("New website")} className="cyan-button rounded-full px-5">
            Book a call <ArrowUpRight className="h-4 w-4" />
          </Button>
        </div>
        <button data-testid="mobile-menu-toggle-button" onClick={() => setOpen(!open)} className="text-white lg:hidden" aria-label="Toggle navigation menu">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>
      {open && (
        <div data-testid="mobile-navigation-menu" className="glass-panel mx-auto mt-3 flex max-w-5xl flex-col gap-5 rounded-3xl p-6 lg:hidden">
          {links.map(([label, target, testId]) => navButton(label, target, `${testId}-mobile`))}
          <Button data-testid="mobile-book-call-button" onClick={() => { setOpen(false); openBooking("New website"); }} className="cyan-button rounded-full">Book a call</Button>
        </div>
      )}
    </header>
  );
}
